<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <h3>Special Pricing</h3>
  <div class="top-form">
    <div class="form-row">
      <div class="form-group width-33">
        <label class="form-label required">Title </label>
        <input [(ngModel)]="model.title" formControlName="title" type="text" class="form-control" />
        <input-errors [control]="form.controls.title" [service]="validationService"></input-errors>
      </div>
      <div class="form-group width-33">
        <label class="form-label required">Payment type </label>
        <select
          [(ngModel)]="model.paymentType"
          (ngModelChange)="onChangePaymentType()"
          formControlName="paymentType"
          class="form-control form-select"
          [attr.disabled]="model.id === null ? null : ''">
          <option *ngFor="let type of service.paymentTypesHtml" [value]="type.id">{{ type.title }}</option>
        </select>
        <input-errors [control]="form.controls.paymentType" [service]="validationService"></input-errors>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group width-33">
        <div class="d-flex justify-content-between align-items-center mb">
          <label class="form-label required">Customers </label>
          <div class="text-right">
            <button (click)="onClickAddUser()" type="button" class="btn btn-outline-primary btn-sm"><i class="fa fa-plus"></i> Add users</button>
          </div>
        </div>
        <div *ngIf="!model.users.length" class="text-center">Empty</div>
        <div *ngIf="model.users.length" class="pills-holder">
          <div *ngFor="let user of model.users" class="pills-btn">
            <span class="text-neutral-n9"> {{ user.email }}</span>
            <i class="far fa-times-circle ms-10 fs-3 text-error-r3" (click)="onClickRemoveUser(user)"></i>
          </div>
        </div>
      </div>
      <div class="form-group width-33">
        <label class="form-label required">Enabled </label>
        <div class="form-check form-switch">
          <input type="checkbox" class="form-check-input medium" [(ngModel)]="model.enabled" formControlName="enabled" />
        </div>
      </div>
      <div class="form-group width-33"></div>
    </div>
  </div>

  <div *ngIf="model.paymentType === 'PREPAID'">
    <div class="d-flex justify-content-between align-items-center mb mt-20">
      <h3>Bundles</h3>
      <div class="text-right">
        <button (click)="addBundle()" type="button" class="btn btn-outline-primary"><i class="fa fa-plus"></i> Add bundle</button>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table table-hover">
        <tbody>
          <tr role="row">
            <th>Product type</th>
            <th>Rate per product/test (EUR)</th>
            <th>Top up value (EUR)</th>
            <th>Pricing visible from</th>
            <th>Visible until</th>
            <th>Purchased credit/access available until</th>
            <th></th>
          </tr>
          <tr *ngIf="!model.bundles.length">
            <td colspan="7" class="text-center">Empty</td>
          </tr>
          <tr *ngFor="let row of model.bundles" [hidden]="row.hidden">
            <td>{{ row.serviceType }}</td>
            <td>{{ row.ratePerUnit }}</td>
            <td [ngClass]="{ 'text-neutral-n6': row.serviceType !== 'MT' }">{{ getCommitment(row) }}</td>
            <td [ngClass]="{ 'text-neutral-n6': row.serviceType !== 'MT' }">{{ getVisibleFrom(row) | date: 'MMMM d, y' }}</td>
            <td [ngClass]="{ 'text-neutral-n6': row.serviceType !== 'MT' }">{{ getVisibleUntil(row) | date: 'MMMM d, y' }}</td>
            <td [ngClass]="{ 'text-neutral-n6': row.serviceType !== 'MT' }">{{ formatValidForSeconds(row) }}</td>
            <td>
              <div class="action-icons-horizontal">
                <span class="action cp">
                  <i class="icon-edit" (click)="editBundle(row)"></i>
                </span>
                <span class="action cp">
                  <i class="far fa-trash-alt" (click)="deleteBundle(row)"></i>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="model.paymentType === 'POSTPAID'">
    <div class="d-flex justify-content-between align-items-center mb mt-20">
      <h3>Analytics</h3>
      <div class="text-right">
        <button (click)="addAnalytics()" type="button" class="btn btn-outline-primary"><i class="fa fa-plus"></i> Add analytics bundle</button>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table table-hover">
        <tbody>
          <tr role="row">
            <th>Rate per product (EUR)</th>
            <th>Valid from</th>
            <th>Visible until</th>
            <th></th>
          </tr>
          <tr *ngIf="!model.analyticsTariffs.length">
            <td colspan="4" class="text-center">Empty</td>
          </tr>
          <tr *ngFor="let at of model.analyticsTariffs" role="row">
            <td>{{ at.rate }}</td>
            <td>{{ at.visibleFrom | date: 'MMMM d, y' }}</td>
            <td>{{ at.visibleUntil | date: 'MMMM d, y' }}</td>
            <td>
              <div class="action-icons-horizontal">
                <span class="action">
                  <i class="icon-edit" (click)="editAnalytics(at)"></i>
                </span>
                <span class="action">
                  <i class="far fa-trash-alt" (click)="deleteAnalytics(at)"></i>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mb mt-20">
      <h3>Tiers</h3>
      <div class="text-right">
        <button (click)="addTier()" type="button" class="btn btn-outline-primary"><i class="fa fa-plus"></i> Add Tier</button>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table table-hover">
        <tbody>
          <tr role="row">
            <th>Product type</th>
            <th>Rate per product/test (EUR)</th>
            <th>Quota</th>
            <th>Commitment (EUR)</th>
            <th>Valid from</th>
            <th>Visible until</th>
            <th></th>
          </tr>
          <tr *ngIf="!model.tiers.length">
            <td colspan="6" class="text-center">Empty</td>
          </tr>
          <tr *ngFor="let row of model.tiers" [hidden]="row.hidden">
            <td>{{ row.serviceType }}</td>
            <td>{{ row.ratePerUnit }}</td>
            <td>{{ row.quota }}</td>
            <td>{{ row.commitment }}</td>
            <td>{{ row.visibleFrom | date: 'MMMM d, y' }}</td>
            <td>{{ row.visibleUntil | date: 'MMMM d, y' }}</td>
            <td>
              <div class="action-icons-horizontal">
                <span class="action">
                  <i class="icon-edit" (click)="editTier(row)"></i>
                </span>
                <span class="action">
                  <i class="far fa-trash-alt" (click)="deleteTier(row)"></i>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="button-holder d-flex justify-content-end gap-20 my-20">
    <a *ngIf="backButtonShow" href="javascript:history.back();" class="btn btn-outline-dark px-25">Cancel</a>
    <button type="submit" [disabled]="!isFormValid()" class="btn btn-primary px-25">Apply</button>
  </div>
</form>

<ng-template #bundleModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ modelBundle.id === null ? 'Create' : 'Edit' }} bundle</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onSubmitBundle()" [formGroup]="formBundle" class="pos-relative form">
      <div class="form-group position-relative">
        <label class="form-label required">Product type</label>
        <div class="d-flex align-items-center position-relative">
          <select
            [(ngModel)]="modelBundle.serviceType"
            (ngModelChange)="onChangeBundleServiceType(); flashCallPricing.suggestFlashCallPrice(modelBundle, model.bundles, formBundle, getVisibleFrom(modelBundle))"
            formControlName="serviceType"
            class="form-control pe-4">
            <option *ngFor="let serviceName of services" [value]="serviceName">{{ serviceName === 'FLASH_CALL' ? 'Flash call' : serviceName }}</option>
          </select>
          <i class="fa fa-chevron-down fs-4 position-absolute top-50 translate-middle-y end-0 me-10 text-muted cp"></i>
        </div>
        <input-errors [control]="formBundle.controls.serviceType" [service]="validationService"></input-errors>
      </div>

      <div class="form-group">
        <label class="form-label required">Rate per product/test (EUR)</label>
        <input
          [(ngModel)]="modelBundle.ratePerUnit"
          formControlName="ratePerUnit"
          (ngModelChange)="onChangeBundleRatePerUnit(); validateBundlePriceRelation()"
          type="text"
          class="form-control" />
        <input-errors [delay]="0" [control]="formBundle.controls.ratePerUnit" [service]="validationService"></input-errors>
      </div>

      <div *ngIf="modelBundle.serviceType === 'MT'">
        <div class="form-group">
          <label class="form-label required">Top up value (EUR)</label>
          <input
            [(ngModel)]="modelBundle.commitment"
            (ngModelChange)="validateBundlePriceRelation()"
            formControlName="commitment"
            type="text"
            class="form-control" />
          <input-errors [delay]="0" [control]="formBundle.controls.commitment" [service]="validationService"></input-errors>
        </div>
        <div class="form-group">
          <label class="form-label">Pricing visible from</label>
          <input-date-time
            [timePicker]="false"
            [value]="modelBundle.visibleFrom"
            [minDate]="getMinDate()"
            [clear]="true"
            (change)="onChangeVisibleFromBundle($event)">
          </input-date-time>
          <input-errors [control]="formBundle.controls.visibleFrom" [service]="validationService"></input-errors>
        </div>
        <div class="form-group">
          <label class="form-label">Visible until</label>
          <input-date-time
            [timePicker]="false"
            [value]="modelBundle.visibleUntil"
            [minDate]="getMinDate()"
            [clear]="true"
            (change)="onChangeVisibleUntilBundle($event)">
          </input-date-time>
          <input-errors [control]="formBundle.controls.visibleUntil" [service]="validationService"></input-errors>
        </div>
        <div class="form-group">
          <label class="form-label">Purchased credit/access available until</label>
          <input-duration
            [unlimitedValue]="true"
            [units]="['h', 'd', 'unlimited']"
            [modelValue]="validForSecondsValue"
            [modelUnit]="validForSecondsUnit"
            (change)="onChangeValidForSeconds($event)">
          </input-duration>
          <input-errors [control]="formBundle.controls.validForSeconds" [service]="validationService"></input-errors>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button type="button" (click)="onSubmitBundle()" [disabled]="isBundleApplyDisabled()" class="btn btn-primary">Apply</button>
    </div>
  </div>
</ng-template>

<ng-template #tierModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">{{ modelTier.id === null ? 'Create' : 'Edit' }} tier</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onSubmitTier()" [formGroup]="formTier" class="pos-relative form">
      <div class="form-group">
        <label class="form-label required">Product type</label>
        <select
          [(ngModel)]="modelTier.serviceType"
          (ngModelChange)="onChangeTierServiceType($event); flashCallPricing.configureFlashCallTier(modelTier, model.tiers, formTier)"
          formControlName="serviceType"
          class="form-control">
          <option *ngFor="let serviceName of services" [value]="serviceName">{{ serviceName === 'FLASH_CALL' ? 'Flash call' : serviceName }}</option>
        </select>
        <input-errors [control]="formTier.controls.serviceType" [service]="validationService"></input-errors>
      </div>
      <div class="form-group">
        <label class="form-label required">Rate per product/test (EUR)</label>
        <input
          [(ngModel)]="modelTier.ratePerUnit"
          (ngModelChange)="onChangeTierRatePerUnit()"
          formControlName="ratePerUnit"
          type="text"
          class="form-control" />
        <input-errors [control]="formTier.controls.ratePerUnit" [service]="validationService"></input-errors>
      </div>
      <div class="form-group" [hidden]="modelTier.serviceType === 'FLASH_CALL'">
        <label class="form-label">Commitment (EUR)</label>
        <input
          [(ngModel)]="modelTier.commitment"
          formControlName="commitment"
          [attr.disabled]="modelTier.serviceType === 'STATISTICS' ? '' : null"
          type="text"
          class="form-control" />
        <input-errors [control]="formTier.controls.commitment" [service]="validationService"></input-errors>
      </div>
      <div class="form-group" [hidden]="modelTier.serviceType === 'STATISTICS'">
        <label class="form-label">Quota</label>
        <input
          [(ngModel)]="modelTier.quota"
          formControlName="quota"
          type="number"
          [attr.disabled]="modelTier.isFirst ? '' : null"
          class="form-control" />
        <input-errors [control]="formTier.controls.quota" [service]="validationService"></input-errors>
      </div>
      <div class="form-group">
        <label class="form-label">Valid from</label>
        <input-date-time
          [timePicker]="false"
          [value]="modelTier.visibleFrom"
          [minDate]="getMinDate()"
          [clear]="true"
          (change)="onChangeVisibleFromTier($event)"></input-date-time>
        <input-errors [control]="formTier.controls.visibleFrom" [service]="validationService"></input-errors>
      </div>
      <div class="form-group">
        <label class="form-label">Visible until</label>
        <input-date-time
          [timePicker]="false"
          [value]="modelTier.visibleUntil"
          [minDate]="getMinDate()"
          [clear]="true"
          (change)="onChangeVisibleUntilTier($event)"></input-date-time>
        <input-errors [control]="formTier.controls.visibleUntil" [service]="validationService"></input-errors>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button type="button" (click)="onSubmitTier()" [disabled]="!formTier.valid" class="btn btn-primary">Apply</button>
    </div>
  </div>
</ng-template>

<ng-template #usersModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Users</h3>
      <button type="button" class="btn-close" (click)="dialogRefTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-users-select
      [multiple]="true"
      [paymentType]="model.paymentType"
      [roles]="['mainaccount', 'deputy']"
      (selectUser)="onSelectUser($event)"
      (unSelectUser)="onUnSelectUser($event)"></app-users-select>
  </div>
</ng-template>

<ng-template #analyticsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Analytics</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form *ngIf="modelAnalyticsTariff" (ngSubmit)="onSubmitAnalytics()" [formGroup]="formAnalyticsTariff" class="pos-relative form">
      <div class="form-group">
        <label class="form-label required">Rate per product (EUR)</label>
        <input [(ngModel)]="modelAnalyticsTariff.rate" formControlName="rate" type="text" class="form-control" />
        <input-errors [control]="formAnalyticsTariff.controls.rate" [service]="validationService"></input-errors>
      </div>
      <div class="form-group">
        <label class="form-label">Valid from</label>
        <input-date-time
          [timePicker]="false"
          [value]="modelAnalyticsTariff.visibleFrom"
          [minDate]="getMinDate()"
          [clear]="true"
          (change)="onChangeVisibleFromAnalytics($event)"></input-date-time>
        <input-errors [control]="formAnalyticsTariff.controls.visibleFrom" [service]="validationService"></input-errors>
      </div>
      <div class="form-group">
        <label class="form-label">Visible until</label>
        <input-date-time
          [timePicker]="false"
          [value]="modelAnalyticsTariff.visibleUntil"
          [minDate]="getMinDate()"
          [clear]="true"
          (change)="onChangeVisibleUntilAnalytics($event)"></input-date-time>
        <input-errors [control]="formAnalyticsTariff.controls.visibleUntil" [service]="validationService"></input-errors>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button type="button" (click)="onSubmitAnalytics()" [disabled]="!formAnalyticsTariff.valid" class="btn btn-primary">Apply</button>
    </div>
  </div>
</ng-template>
